<ng-template optSiteHeader></ng-template>
<router-outlet></router-outlet>
<ng-template optSiteFooter></ng-template>
